// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tool-panel {
    background-color: #efefef;
    padding: 10px;
    border-radius: 6px;
    font-family: sans-serif;
    font-size: 14px;
    width: fit-content;
    height: fit-content;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    display: inline-block;
}

.section {
    margin-bottom: 14px;
}

.section-title {
    text-align: start;
    font-weight: bold;
    margin-bottom: 6px;
    color: #444;
    font-size: .8em;
}

/* Layout horizontal para opciones */
.color-options,
.stroke-options {
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-wrap: nowrap;
    align-items: center;
}

/* Botones de color */
.color-box {
    width: 24px;
    height: 24px;
    border: 2px solid #ccc;
    border-radius: 6px;
    cursor: pointer;
    transition: border-color 0.2s ease;
}

.color-box.active {
    border-color: rgb(62, 62, 150);
}

/* Botones de grosor */
.stroke-button {
    background-color: transparent;
    border: none;
    border-radius: 6px;
    padding: 6px;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.stroke-button.active {
    background-color: rgb(62, 62, 150);;
}

.stroke-line {
    background-color: #444;
    border-radius: 2px;
    width: 24px;
}
.stroke-button.active .stroke-line {
    background-color: white;
}

.stroke-line.thin {
    height: 2px;
}

.stroke-line.medium {
    height: 4px;
}

.stroke-line.thick {
    height: 8px;
}

.text-options {
    display: flex;
    gap: 8px;
    align-items: center;
}

.font-size-button {
    border: none;
    flex: 1;
    padding: 2px;
    border-radius: 8px;
    background-color: transparent;
    color: #444;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.font-size-button.active {
    background-color: rgb(62, 62, 150);
    color: white;
}
`, "",{"version":3,"sources":["webpack://./react/features/whiteboard/custom-ui/styles/tool-panel.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA,oCAAoC;AACpC;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,sBAAsB;AACtB;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,8DAA8D;IAC9D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,uDAAuD;IACvD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB","sourcesContent":[".tool-panel {\n    background-color: #efefef;\n    padding: 10px;\n    border-radius: 6px;\n    font-family: sans-serif;\n    font-size: 14px;\n    width: fit-content;\n    height: fit-content;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n    display: inline-block;\n}\n\n.section {\n    margin-bottom: 14px;\n}\n\n.section-title {\n    text-align: start;\n    font-weight: bold;\n    margin-bottom: 6px;\n    color: #444;\n    font-size: .8em;\n}\n\n/* Layout horizontal para opciones */\n.color-options,\n.stroke-options {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    flex-wrap: nowrap;\n    align-items: center;\n}\n\n/* Botones de color */\n.color-box {\n    width: 24px;\n    height: 24px;\n    border: 2px solid #ccc;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: border-color 0.2s ease;\n}\n\n.color-box.active {\n    border-color: rgb(62, 62, 150);\n}\n\n/* Botones de grosor */\n.stroke-button {\n    background-color: transparent;\n    border: none;\n    border-radius: 6px;\n    padding: 6px;\n    cursor: pointer;\n    transition: background-color 0.2s ease, border-color 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.stroke-button.active {\n    background-color: rgb(62, 62, 150);;\n}\n\n.stroke-line {\n    background-color: #444;\n    border-radius: 2px;\n    width: 24px;\n}\n.stroke-button.active .stroke-line {\n    background-color: white;\n}\n\n.stroke-line.thin {\n    height: 2px;\n}\n\n.stroke-line.medium {\n    height: 4px;\n}\n\n.stroke-line.thick {\n    height: 8px;\n}\n\n.text-options {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.font-size-button {\n    border: none;\n    flex: 1;\n    padding: 2px;\n    border-radius: 8px;\n    background-color: transparent;\n    color: #444;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s ease, color 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.font-size-button.active {\n    background-color: rgb(62, 62, 150);\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
